import { BKJAvatar, BKJButton } from '@bookjane2/bookjane-design-library';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import {
  NavigationButton,
  NavigationButtonsWrapper,
} from 'modals/ShiftModal/src/views/DetailView/DetailView.styled';
import { useFetchTimeOffDataContext } from 'modals/TimeOffModal/contexts/FetchTimeOff.data.context';
import { formatDetailTimeOffStartTimeEndTime } from 'modals/TimeOffModal/views/DetailTimeOffView/DetailTimeOffView.constants';
import { useDetailTimeOffViewPropsContext } from 'modals/TimeOffModal/views/DetailTimeOffView/DetailTimeOffView.props.context';
import {
  DetailTimeOffViewBlockWrapper,
  DetailTimeOffViewHeaderWrapper,
  DetailTimeOffViewJaneInfoWrapper,
  DetailTimeOffViewStartTimeEndTimeWrapper,
  DetailTimeOffViewWrapper,
  MainTitle,
  TimeOffJaneStyledBKJIcon,
  AvatarIconWrapper,
} from 'modals/TimeOffModal/views/DetailTimeOffView/DetailTimeOffView.styled';
import { DetailTimeOffViewTabComponentMap } from 'modals/TimeOffModal/views/DetailTimeOffView/DetailTimeOffView.types';
import { useTranslation } from 'hooks/useTranslation';
import { FC, Fragment } from 'react';
import { ActivitiesType } from 'types/users.types';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';
import { useSelector } from 'react-redux';
import { isUserReadOnlySelector } from 'store/selectors/userSelectors/isUserReadOnlySelector';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

export const DetailTimeOffViewComponent: FC = () => {
  const {
    isEditable,
    goToEditTimeOffView,
    goToDeleteTimeOffView,
    activeTab,
    goToGeneralTab,
    goToActivityTab,
  } = useDetailTimeOffViewPropsContext();

  const isReadOnly = useSelector(isUserReadOnlySelector);

  const ActiveTabComponent = DetailTimeOffViewTabComponentMap[activeTab];

  const { t } = useTranslation();

  const {
    data: {
      fetchTimeOff: {
        activities,
        startTime,
        endTime,
        community,
        title: { value: timeOffTitle = t('schedule:TIME_OFF') },
        jane: {
          firstName,
          lastName,
          communityName,
          avatarUrls: { origin },
          pendingSignup,
        },
      },
    },
  } = useFetchTimeOffDataContext();

  const { timeZone, value } = getCurrentlySelectedLocation();
  const isShiftFromCurrentLocation = community?.displayId === value;
  const isUserTimeFormat24h = useSelector(isUserTimeFormat24hSelector);

  return (
    <Fragment>
      <NavigationButtonsWrapper>
        <NavigationButton
          isDisabled={false}
          isActive={activeTab === 'General'}
          onClick={goToGeneralTab}
        >
          {t('common:GENERAL')}
        </NavigationButton>
        <NavigationButton
          isDisabled={false}
          isActive={activeTab === 'Activity'}
          onClick={goToActivityTab}
        >
          {t('common:ACTIVITY')}
        </NavigationButton>
      </NavigationButtonsWrapper>
      {activeTab === 'General' && (
        <DetailTimeOffViewWrapper>
          <DetailTimeOffViewHeaderWrapper>
            <MainTitle>{timeOffTitle}</MainTitle>
            <DetailTimeOffViewBlockWrapper>
              <AvatarIconWrapper>
                <BKJAvatar
                  width="30px"
                  height="30px"
                  fallbackAvatarColor={'TextDarkGrey'}
                  src={origin}
                  showPendingSignUp={false}
                />
                {pendingSignup && (
                  <TimeOffJaneStyledBKJIcon
                    iconName="PendingSignup"
                    left="17"
                    top="16"
                    width="20"
                  />
                )}
              </AvatarIconWrapper>
              <DetailTimeOffViewJaneInfoWrapper>
                <div>{`${firstName} ${lastName}`}</div>
                <div>{`${communityName}`}</div>
              </DetailTimeOffViewJaneInfoWrapper>
            </DetailTimeOffViewBlockWrapper>
            <DetailTimeOffViewStartTimeEndTimeWrapper>
              <div>
                {t('schedule:STARTS')}:{' '}
                {formatDetailTimeOffStartTimeEndTime(startTime, timeZone, isUserTimeFormat24h)}
              </div>
              <div>
                {t('schedule:ENDS')}:{' '}
                {formatDetailTimeOffStartTimeEndTime(endTime, timeZone, isUserTimeFormat24h)}
              </div>
            </DetailTimeOffViewStartTimeEndTimeWrapper>
          </DetailTimeOffViewHeaderWrapper>
        </DetailTimeOffViewWrapper>
      )}
      <ActiveTabComponent timeZone={timeZone} activities={activities as ActivitiesType[]} />

      {isEditable && isShiftFromCurrentLocation && !isReadOnly && (
        <BKJSideModalFooter justifyContent="space-between">
          <BKJButton variant="RedText" onClick={goToDeleteTimeOffView} width="fit-content">
            {t('auth:DELETE')}
          </BKJButton>
          <BKJButton variant="PurpleOutlined" onClick={goToEditTimeOffView} width="180px">
            {t('schedule:EDIT')}
          </BKJButton>
        </BKJSideModalFooter>
      )}
    </Fragment>
  );
};
